import { METHODS } from '../schema.js';
export const RPC_VERSION = 1;
//# sourceMappingURL=types.js.map